// Originally generated from the single-file app (index.html) during the React migration.
// Edit freely: this file is now the source of truth.
import type { SystemAnalysisDataset } from "@/domain/systemAnalysis";

/** Domain/criterion skeleton shown before any real system analysis is loaded. */
export const SAMPLE_SYSTEM_ANALYSIS: SystemAnalysisDataset = {
  analyses: [
    {
      analysisId: "national_2024",
      analysisName: {
        no: "Eksempeldata",
        en: "Sample data",
      },
      year: 2024,
      locations: [
        {
          locationId: "all",
          locationName: {
            no: "Alle lokasjoner",
            en: "All locations",
          },
        },
      ],
      domainsByLocation: {
        all: [
          {
            id: "A",
            titleNo: "Comprehensive evidence-based interventions",
            titleEn: "Comprehensive evidence-based interventions",
            items: [
              {
                id: "A1.1",
                titleNo: "Tiltak målrettet alle aldre",
                titleEn: "Interventions targeting all age groups",
                criterionNo:
                  "Systemet implementerer evidensbaserte tiltak rettet mot alle aldersgrupper.",
                criterionEn:
                  "The system implements evidence-based interventions targeting all age groups.",
                assessmentNo: "Tiltak for flere aldersgrupper er implementert i ulike sektorer.",
                assessmentEn:
                  "Interventions for several age groups are implemented across sectors.",
                evidenceNo:
                  "Nasjonale planer og rapportering viser dekning på tvers av aldersgrupper.",
                evidenceEn: "National plans and reporting indicate coverage across age groups.",
                status: "fulfilled",
                sources: [
                  {
                    labelNo: "Rapport fra Helsedirektoratet (2024)",
                    labelEn: "Directorate of Health report (2024)",
                    url: "",
                  },
                ],
                workingCommentNo: "Datagrunnlaget virker konsistent på tvers av regioner.",
                workingCommentEn: "Data appears consistent across regions.",
                metadata: {
                  sectorNo: "Helse",
                  sectorEn: "Health",
                  interventionTypeNo: "Universelle tiltak",
                  interventionTypeEn: "Universal interventions",
                  interventionReachNo: "Befolkningsrettet",
                  interventionReachEn: "Population level",
                },
              },
              {
                id: "A2.1",
                titleNo: "Tiltak på alle risikonivåer",
                titleEn: "Interventions targeting all levels of risk",
                criterionNo:
                  "Systemet implementerer evidensbaserte tiltak rettet mot alle nivåer av risiko.",
                criterionEn:
                  "The system implements evidence-based interventions targeting all levels of risk.",
                assessmentNo:
                  "Evidence-based interventions implemented targeting each level of risk.",
                assessmentEn:
                  "Evidence-based interventions implemented targeting each level of risk.",
                evidenceNo:
                  "Bruk av data i strategi, mange rapporter, bruk av data i både strategi- og planarbeid på lokalt nivå.",
                evidenceEn:
                  "Use of data in strategy and planning, with broad reporting at local level.",
                status: "fulfilled",
                sources: [
                  {
                    labelNo: "Rapport fra Helsedirektoratet (2024)",
                    labelEn: "Directorate of Health report (2024)",
                    url: "",
                  },
                ],
                workingCommentNo: "Preliminary evidence rating suggested by AI.",
                workingCommentEn: "Preliminary evidence rating suggested by AI.",
                metadata: {
                  sectorNo: "Helse",
                  sectorEn: "Health",
                  interventionTypeNo:
                    "Tiltak rettet mot både hele befolkningen og utvalgte grupper.",
                  interventionTypeEn:
                    "Interventions targeting both the whole population and selected groups.",
                  interventionReachNo: "Alle. Universell og selektive tiltak.",
                  interventionReachEn: "All. Universal and selective interventions.",
                },
              },
              {
                id: "A3.1",
                titleNo: "Tiltak i alle settinger",
                titleEn: "Interventions in all settings",
                criterionNo: "Tiltak gjennomføres i relevante settinger.",
                criterionEn: "Interventions are delivered in relevant settings.",
                assessmentNo: "Flere settinger er dekket gjennom eksisterende innsats.",
                assessmentEn: "Multiple settings are covered through existing efforts.",
                evidenceNo: "Sektorvise planer viser tiltak i skole, helse og lokalsamfunn.",
                evidenceEn:
                  "Sector plans show interventions in school, health and community settings.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Flere sektorer",
                  sectorEn: "Multiple sectors",
                  interventionTypeNo: "Kombinerte tiltak",
                  interventionTypeEn: "Combined interventions",
                  interventionReachNo: "Blandet",
                  interventionReachEn: "Mixed",
                },
              },
            ],
          },
          {
            id: "B",
            titleNo: "Supportive policies and regulations",
            titleEn: "Supportive policies and regulations",
            items: [
              {
                id: "B1.1",
                titleNo: "Finansiering av forebygging",
                titleEn: "Financing prevention",
                criterionNo: "Finansiering støtter forebyggende arbeid.",
                criterionEn: "Financing supports prevention work.",
                assessmentNo: "Delvis stabil finansiering på tvers av nivåer.",
                assessmentEn: "Partly stable financing across levels.",
                evidenceNo: "Budsjettanalyse og styringsdokumenter.",
                evidenceEn: "Budget analysis and steering documents.",
                status: "partially_fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Forvaltning",
                  sectorEn: "Governance",
                  interventionTypeNo: "Finansieringsmekanismer",
                  interventionTypeEn: "Funding mechanisms",
                  interventionReachNo: "Systemnivå",
                  interventionReachEn: "System level",
                },
              },
              {
                id: "B2.1",
                titleNo: "Forebygging av rusbruk i utdanningssektoren",
                titleEn: "Prevention in the education sector",
                criterionNo: "Regelverk støtter forebygging i utdanningssektoren.",
                criterionEn: "Regulation supports prevention in education.",
                assessmentNo: "Gode føringer i sentrale dokumenter.",
                assessmentEn: "Clear direction in central documents.",
                evidenceNo: "Nasjonale retningslinjer og sektordokumenter.",
                evidenceEn: "National guidelines and sector documents.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Utdanning",
                  sectorEn: "Education",
                  interventionTypeNo: "Regulatoriske tiltak",
                  interventionTypeEn: "Regulatory interventions",
                  interventionReachNo: "Skole",
                  interventionReachEn: "School",
                },
              },
              {
                id: "B3.1",
                titleNo: "Forebygging av rusbruk i arbeidslivet",
                titleEn: "Prevention in the workplace",
                criterionNo: "Policy i arbeidslivet støtter forebygging.",
                criterionEn: "Workplace policy supports prevention.",
                assessmentNo: "Delvis implementerte styringskrav.",
                assessmentEn: "Partly implemented governance requirements.",
                evidenceNo: "Sektorrapporter og veiledere.",
                evidenceEn: "Sector reports and guidance.",
                status: "partially_fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Arbeidsliv",
                  sectorEn: "Worklife",
                  interventionTypeNo: "Arbeidslivstiltak",
                  interventionTypeEn: "Workplace interventions",
                  interventionReachNo: "Yrkesaktive",
                  interventionReachEn: "Working population",
                },
              },
            ],
          },
          {
            id: "C",
            titleNo: "Undertaking and utilization of research",
            titleEn: "Undertaking and utilization of research",
            items: [
              {
                id: "C1.1",
                titleNo: "Skolebaserte undersøkelser (kunnskapsgrunnlag)",
                titleEn: "School surveys (knowledge base)",
                criterionNo: "Systemet bruker skoledata i analysearbeid.",
                criterionEn: "The system uses school data in analysis work.",
                assessmentNo: "Data brukes jevnlig i planarbeid.",
                assessmentEn: "Data is used regularly in planning.",
                evidenceNo: "Rapporteringsrutiner og indikatorer.",
                evidenceEn: "Reporting routines and indicators.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Utdanning",
                  sectorEn: "Education",
                  interventionTypeNo: "Kunnskapsinnhenting",
                  interventionTypeEn: "Knowledge generation",
                  interventionReachNo: "Skoleelever",
                  interventionReachEn: "School students",
                },
              },
              {
                id: "C2.1",
                titleNo: "Bruk av data i strategi og plan",
                titleEn: "Use of data in strategy and planning",
                criterionNo: "Data integreres i strategi og plan.",
                criterionEn: "Data is integrated in strategy and planning.",
                assessmentNo: "Data brukes i flere prosesser.",
                assessmentEn: "Data is used in several processes.",
                evidenceNo: "Planverk og analyser.",
                evidenceEn: "Plans and analyses.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Forvaltning",
                  sectorEn: "Governance",
                  interventionTypeNo: "Beslutningsstøtte",
                  interventionTypeEn: "Decision support",
                  interventionReachNo: "Systemnivå",
                  interventionReachEn: "System level",
                },
              },
              {
                id: "C3.1",
                titleNo: "Evaluering av forebyggende tiltak",
                titleEn: "Evaluation of preventive interventions",
                criterionNo: "Forebyggende tiltak evalueres systematisk.",
                criterionEn: "Preventive interventions are evaluated systematically.",
                assessmentNo: "Evaluering gjennomføres, men ikke fullt dekkende.",
                assessmentEn: "Evaluation is conducted but not fully comprehensive.",
                evidenceNo: "Evalueringer fra utvalgte programmer.",
                evidenceEn: "Evaluations from selected programs.",
                status: "partially_fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Flere sektorer",
                  sectorEn: "Multiple sectors",
                  interventionTypeNo: "Evalueringsaktiviteter",
                  interventionTypeEn: "Evaluation activities",
                  interventionReachNo: "Delvis",
                  interventionReachEn: "Partial",
                },
              },
              {
                id: "C4.1",
                titleNo: "Evaluering av forebyggende intervensjoner",
                titleEn: "Evaluation of preventive interventions",
                criterionNo: "Det finnes tilstrekkelig dokumentasjon for vurdering.",
                criterionEn: "There is sufficient documentation for assessment.",
                assessmentNo: "Dokumentasjon mangler for enkelte intervensjoner.",
                assessmentEn: "Documentation is lacking for parts of the interventions.",
                evidenceNo: "Ufullstendige datasett i flere områder.",
                evidenceEn: "Incomplete datasets across several areas.",
                status: "insufficient_information",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Flere sektorer",
                  sectorEn: "Multiple sectors",
                  interventionTypeNo: "Dokumentasjon",
                  interventionTypeEn: "Documentation",
                  interventionReachNo: "Uavklart",
                  interventionReachEn: "Unclear",
                },
              },
            ],
          },
          {
            id: "D",
            titleNo: "Coordination and coherence",
            titleEn: "Coordination and coherence",
            items: [
              {
                id: "D1.1",
                titleNo: "Koordinering på nasjonalt nivå",
                titleEn: "National coordination",
                criterionNo: "Nasjonale aktører er koordinert.",
                criterionEn: "National actors are coordinated.",
                assessmentNo: "Koordinering er delvis etablert.",
                assessmentEn: "Coordination is partly established.",
                evidenceNo: "Mandater og møtestrukturer.",
                evidenceEn: "Mandates and meeting structures.",
                status: "partially_fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Forvaltning",
                  sectorEn: "Governance",
                  interventionTypeNo: "Koordineringsmekanismer",
                  interventionTypeEn: "Coordination mechanisms",
                  interventionReachNo: "Nasjonalt",
                  interventionReachEn: "National",
                },
              },
              {
                id: "D2.1",
                titleNo: "Koordinering regionalt/kommunalt",
                titleEn: "Regional/municipal coordination",
                criterionNo: "Regional og kommunal koordinering fungerer.",
                criterionEn: "Regional and municipal coordination is functioning.",
                assessmentNo: "Vesentlige koordinasjonsbrudd i flere områder.",
                assessmentEn: "Significant coordination gaps in multiple areas.",
                evidenceNo: "Kartlegging av samhandling og ansvarslinjer.",
                evidenceEn: "Mapping of collaboration and responsibilities.",
                status: "not_fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Kommune",
                  sectorEn: "Municipality",
                  interventionTypeNo: "Samordning",
                  interventionTypeEn: "Alignment",
                  interventionReachNo: "Regionalt/kommunalt",
                  interventionReachEn: "Regional/municipal",
                },
              },
              {
                id: "D3.1",
                titleNo: "Policy-koherens på tvers av nivåer",
                titleEn: "Policy coherence across levels",
                criterionNo: "Policy er konsistent på tvers av styringsnivåer.",
                criterionEn: "Policy is coherent across governance levels.",
                assessmentNo: "Koherens finnes i sentrale policyområder.",
                assessmentEn: "Coherence exists in key policy areas.",
                evidenceNo: "Sammenstilling av styringsdokumenter.",
                evidenceEn: "Synthesis of governance documents.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Forvaltning",
                  sectorEn: "Governance",
                  interventionTypeNo: "Policyarbeid",
                  interventionTypeEn: "Policy work",
                  interventionReachNo: "Tverrsektorielt",
                  interventionReachEn: "Cross-sector",
                },
              },
            ],
          },
          {
            id: "E",
            titleNo: "Competent delivery structure",
            titleEn: "Competent delivery structure",
            items: [
              {
                id: "E1.1",
                titleNo: "Opplæring av de som leverer tiltak",
                titleEn: "Training of implementers",
                criterionNo: "Implementører har nødvendig opplæring.",
                criterionEn: "Implementers have necessary training.",
                assessmentNo: "God dekning i flere tjenester.",
                assessmentEn: "Good coverage in several services.",
                evidenceNo: "Kompetanseplaner og opplæringsdata.",
                evidenceEn: "Competence plans and training data.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Flere sektorer",
                  sectorEn: "Multiple sectors",
                  interventionTypeNo: "Kompetansetiltak",
                  interventionTypeEn: "Capacity building",
                  interventionReachNo: "Tjenesteytere",
                  interventionReachEn: "Service providers",
                },
              },
              {
                id: "E2.1",
                titleNo: "Kompetanse hos beslutningstakere",
                titleEn: "Competence among decision-makers",
                criterionNo: "Beslutningstakere har relevant kompetanse.",
                criterionEn: "Decision-makers have relevant competence.",
                assessmentNo: "Kompetansen er ujevnt dokumentert.",
                assessmentEn: "Competence is unevenly documented.",
                evidenceNo: "Begrenset dokumentasjon i deler av styringslinjen.",
                evidenceEn: "Limited documentation in parts of the governance chain.",
                status: "partially_fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Forvaltning",
                  sectorEn: "Governance",
                  interventionTypeNo: "Lederkompetanse",
                  interventionTypeEn: "Leadership competence",
                  interventionReachNo: "Ledelsesnivå",
                  interventionReachEn: "Leadership level",
                },
              },
            ],
          },
          {
            id: "F",
            titleNo: "Sustainability",
            titleEn: "Sustainability",
            items: [
              {
                id: "F1.1",
                titleNo: "Forebyggingspolitikk (3-5 års perspektiv)",
                titleEn: "Prevention policy (3-5 year perspective)",
                criterionNo: "Forebygging er forankret i langsiktig politikk.",
                criterionEn: "Prevention is anchored in long-term policy.",
                assessmentNo: "Langsiktig politisk forankring er etablert.",
                assessmentEn: "Long-term policy anchoring is established.",
                evidenceNo: "Planstrategier og sektorplaner.",
                evidenceEn: "Planning strategies and sector plans.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Forvaltning",
                  sectorEn: "Governance",
                  interventionTypeNo: "Strategisk forankring",
                  interventionTypeEn: "Strategic anchoring",
                  interventionReachNo: "Systemnivå",
                  interventionReachEn: "System level",
                },
              },
              {
                id: "F2.1",
                titleNo: "Tilstrekkelig finansiering",
                titleEn: "Adequate financing",
                criterionNo: "Finansiering er tilstrekkelig og forutsigbar.",
                criterionEn: "Financing is adequate and predictable.",
                assessmentNo: "Finansiering vurderes som tilstrekkelig i nåværende periode.",
                assessmentEn: "Financing is assessed as adequate in the current period.",
                evidenceNo: "Budsjett og flerårige prioriteringer.",
                evidenceEn: "Budgets and multi-year priorities.",
                status: "fulfilled",
                sources: [],
                workingCommentNo: "",
                workingCommentEn: "",
                metadata: {
                  sectorNo: "Forvaltning",
                  sectorEn: "Governance",
                  interventionTypeNo: "Finansiering",
                  interventionTypeEn: "Financing",
                  interventionReachNo: "Systemnivå",
                  interventionReachEn: "System level",
                },
              },
            ],
          },
        ],
      },
    },
  ],
};
